// extracted by mini-css-extract-plugin
module.exports = {"settings":"Settings_settings__2w53b","columnFlex":"Settings_columnFlex__2x92H","content":"Settings_content__37BKK","tabPane":"Settings_tabPane__2-fmJ","row":"Settings_row__j_ck7"};